import { SET_PAGES } from "@/store/mutation-types";
import { POLICY_CONFIG_LIST } from "@/store/mutation-types/policyConfig.type";
import { convertObjectToParams, PAGE_DEFAULT } from "@/utils";
import http from "../helpers/httpInterceptor";

const state = () => ({
  policyConfigList: [],
  pages: PAGE_DEFAULT,
});

// mutations
const mutations = {
  [POLICY_CONFIG_LIST](state, data) {
    state.policyConfigList = data;
  },
  [SET_PAGES](state, data) {
    state.pages = data;
  },
};

// actions
const actions = {
  getPolicyConfigList({ commit }, payload) {
    http
      .get(`/tms/work-schedule-manager/find-all${convertObjectToParams(payload)}`)
      .then((res) => {
        const {
          data,
          page: { page, size, total_element },
        } = res.data;
        commit(POLICY_CONFIG_LIST, data ?? []);
        commit(SET_PAGES, {
          page,
          size,
          total: total_element,
        });
        return res.data;
      })
      .catch((error) => {
        commit(POLICY_CONFIG_LIST, []);
        commit(SET_PAGES, PAGE_DEFAULT);
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
